import React, { useEffect, useRef, useState } from 'react';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

export default function TurnstileGate({ onVerify }) {
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;
  const isDev = import.meta.env.DEV;
  
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  // Carga dinámica del script de Turnstile
  useEffect(() => {
    if (!siteKey) return;

    const existingScript = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    
    if (existingScript) {
      if (window.turnstile) {
        setLoaded(true);
      } else {
        existingScript.addEventListener('load', () => setLoaded(true));
      }
      return;
    }

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);

    return () => {
      // Limpieza del widget al desmontar
      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, [siteKey]);

  // Renderiza el widget una vez que el script ha cargado
  useEffect(() => {
    if (loaded && siteKey && containerRef.current && window.turnstile && widgetIdRef.current === null) {
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        callback: (token) => {
          if (typeof onVerify === 'function') {
            onVerify(token);
          }
        }
      });
    }
  }, [loaded, siteKey, onVerify]);

  // Estado: Protección no configurada
  if (!siteKey) {
    return (
      <div style={{ padding: '1rem', border: '1px solid #f39c12', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '4px' }}>
        <p style={{ margin: '0 0 0.5rem 0', fontWeight: 'bold' }}>
          Protección anti-bot no configurada
        </p>
        {isDev && (
          <button 
            type="button" 
            onClick={() => onVerify && onVerify('dev-bypass-token')} 
            style={{ cursor: 'pointer', padding: '0.25rem 0.5rem' }}
          >
            Continuar (Modo Dev)
          </button>
        )}
      </div>
    );
  }

  // Estado: Cargando widget
  if (!loaded) {
    return (
      <div style={{ minHeight: '65px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #dee2e6' }}>
        <span>Cargando verificación...</span>
      </div>
    );
  }

  // Estado: Widget listo
  return <div ref={containerRef} style={{ minHeight: '65px' }}></div>;
}
